import React from 'react';
import { X } from 'lucide-react';

interface DisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto relative">
        <button
          onClick={onClose}
          className="absolute left-4 top-4 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
        
        <div className="p-6 text-right">
          <h2 className="text-2xl font-bold mb-6 text-gray-800">כתב ויתור ותנאי שימוש – "מתי כדאי"</h2>
          
          <div className="space-y-6">
            <section>
              <h3 className="font-bold text-lg mb-2">1. מידע כללי</h3>
              <p className="text-gray-700">
                אתר "מתי כדאי" מספק מידע כללי בנושאים הקשורים לתזמון נכון של פעולות, רכישות, נסיעות, שתילה, ועוד.
                המידע באתר מוצג למטרות עזר, השראה ונוחות בלבד.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-lg mb-2">2. בינה מלאכותית וגורמים חיצוניים</h3>
              <p className="text-gray-700">
                חלק מהמידע המוצג באתר מבוסס על ניתוחים של בינה מלאכותית (AI), בין היתר באמצעות שירותים כמו GPT של OpenAI, ועל מקורות כלליים כגון מאגרי מידע ציבוריים וניסיון מצטבר.
                התשובות אינן ניתנות על ידי מומחים מוסמכים, ואינן מהוות ייעוץ מקצועי, פיננסי, משפטי, רפואי או אחר.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-lg mb-2">3. הסתייגות מאחריות</h3>
              <p className="text-gray-700">
                האתר אינו אחראי לדיוק, שלמות או עדכניות המידע.
                כל שימוש במידע באתר נעשה באחריות המשתמש בלבד.
                החלטות שיתקבלו על בסיס המידע באתר הינן באחריות הבלעדית של המשתמש.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-lg mb-2">4. אי-תלות באתר "מתי כדאי"</h3>
              <p className="text-gray-700">
                המידע המוצג באתר אינו משקף בהכרח את דעת מפעילי האתר, ואין לראות בו המלצה אישית או התחייבות כלשהי מצד האתר או מפעיליו.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-lg mb-2">5. קישורים והפניות חיצוניות</h3>
              <p className="text-gray-700">
                ייתכנו קישורים או אזכורים לשירותים, מוצרים או אתרים חיצוניים – אין לראות בכך המלצה או אחריות מצד האתר.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-lg mb-2">6. פרטיות ואבטחה</h3>
              <p className="text-gray-700">
                האתר אינו אוסף מידע אישי מזוהה ללא הסכמה מפורשת. שימוש בכלי חיפוש או שליחת שאלה יתועד לצורך שיפור חוויית המשתמש בלבד, בהתאם למדיניות הפרטיות.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-lg mb-2">7. שינויים ותוקף התנאים</h3>
              <p className="text-gray-700">
                מפעילי האתר שומרים לעצמם את הזכות לעדכן את תנאי השימוש מעת לעת. שימוש באתר מהווה הסכמה לתנאים אלו.
              </p>
            </section>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <p className="text-gray-700 font-medium">
                🧠 אנא השתמשו באתר "מתי כדאי" בשיקול דעת ובזהירות.
                <br />
                בכל מקרה של ספק – תמיד מומלץ להתייעץ עם גורם מקצועי מוסמך.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};